import edTreatmentImage from '@/images/navigation/ed-treatment.jpg'
import hairLossImage from '@/images/navigation/hair-loss.jpg'
import peTreatmentImage from '@/images/navigation/pe-treatment.jpg'
import weightLossImage from '@/images/navigation/weight-loss.jpg'
import type { PricingTemplateName } from '@/lib/cms/template-data'
import type { ServiceIconKind } from '@/shared/components/ServiceIcon'
import {
  ED_LANDING_PAGE,
  MHL_LANDING_PAGE,
  PE_LANDING_PAGE,
  WL_LANDING_PAGE,
} from '@/lib/links'
import type { StaticImageData } from 'next/image'

export type ServiceNavigationItem = {
  name: string
  href: string
  icon: ServiceIconKind
  priceName: PricingTemplateName
  pricePrefix?: string
  isNew?: boolean
}

export const serviceNavigationItems: ServiceNavigationItem[] = [
  {
    name: 'Medical certificates',
    href: '/medical-certificates-online',
    icon: 'certificate',
    priceName: 'medicalCertificateSingleDay',
    pricePrefix: 'from',
  },
  {
    name: 'Online prescriptions',
    href: '/prescriptions-online',
    icon: 'prescription',
    priceName: 'prescription',
    pricePrefix: 'from',
  },
  {
    name: 'Telehealth consultations',
    href: '/telehealth-consultation',
    icon: 'telehealth',
    priceName: 'generalConsultation',
  },
  {
    name: 'Blood tests',
    href: '/blood-tests-online',
    icon: 'bloodTest',
    priceName: 'generalConsultation',
  },
  {
    name: 'Radiology referrals',
    href: '/radiology-referrals-online',
    icon: 'radiology',
    priceName: 'generalConsultation',
    isNew: true,
  },
  {
    name: 'Specialist referrals',
    href: '/specialist-referral-online',
    icon: 'specialistReferral',
    priceName: 'generalConsultation',
  },
]

export type TreatmentNavigationItem = {
  name: string
  href: string
  image: StaticImageData
  description: string
}

export const treatmentNavigationItems: TreatmentNavigationItem[] = [
  {
    name: 'Weight loss',
    href: WL_LANDING_PAGE,
    image: weightLossImage,
    description: 'Doctor-led plan, ongoing care',
  },
  {
    name: 'ED treatment',
    href: ED_LANDING_PAGE,
    image: edTreatmentImage,
    description: 'Private assessment, discreet delivery',
  },
  {
    name: 'Premature ejaculation',
    href: PE_LANDING_PAGE,
    image: peTreatmentImage,
    description: 'Private assessment and treatment options',
  },
  {
    name: 'Male hair loss',
    href: MHL_LANDING_PAGE,
    image: hairLossImage,
    description: 'Private assessment and treatment options',
  },
]

export const aboutNavigationItems = [
  {
    name: 'Careers',
    href: '/careers',
    description: 'Join the team',
    section: 'company',
  },
  {
    name: 'FAQs',
    href: '/faqs',
    description: 'Straight answers, no jargon',
    section: 'help',
  },
  {
    name: 'Blog',
    href: '/blog',
    description: 'Health advice from our doctors',
    section: 'company',
  },
  {
    name: 'Glossary',
    href: '/glossary',
    description: 'Medical terms, decoded',
    section: 'help',
  },
  {
    name: 'Pathology & radiology results',
    href: '/pathology-radiology-results',
    description: 'How your results reach you and your doctor',
    section: 'featured',
  },
] as const
